<template>
  <div class="catalog-preview-component cpc">
    <div class="pl-2 ml-3">
      <b-row class="no-gutters">
        <h3>{{ category.Title }}</h3>
      </b-row>
      <div v-if="IsNullOrUndefined(category,'ChildCategories')">
        <loading-spinner />
      </div>
      <template v-if="subCategories.length != 0">
        <b-row
          :class="{ 'no-gutters': true,
                    'cpc__mega-menu-categories-preview': true,
                    'cpc__mega-menu-categories-preview--item-start': true
          }"
        >
          <b-col
            v-for="subCategory in subCategories"
            :key="subCategory.Id"
            sm="2"
            class="cpc__mega-menu-categories-preview__col hmmc__menu-item"
          >
            <catalog-card
              :title="subCategory.Title"
              :category-image-id="subCategory.Image"
              :category-id="subCategory.Id"
            />
          </b-col>
        </b-row>
      </template>
    </div>
    <div class="row no-gutters pl-2">
      <!-- Related Documents -->
      <div v-if="!areRelatedDocumentsLoading && relatedDocuments !== undefined && relatedDocuments.length" class="col">
        <h4 class="catalogItemSubHeader">
          Related Documents
        </h4>
        <ul class="cpc__related-docs-ul">
          <li
            v-for="relatedDocument in relatedDocuments"
            :key="relatedDocument.Content"
            class="cpc__related-doc-li"
          >
            <a :href="MediaUrl(relatedDocument.Content)" target="_blank" class="catalogAdditionalItemLink">{{ relatedDocument.DetailProperties.Title }}</a>
          </li>
        </ul>
      </div>
      <div v-if="areRelatedDocumentsLoading === true" class="col">
        <loading-spinner />
      </div>
      <!-- Fully Implemented, but not desired at this time, See Also Items -->
      <!--
      <div v-if="!areSeeAlsoItemsLoading && seeAlsoItems !== undefined && seeAlsoItems.length > 0" class="col see-also">
        <h4 class="catalogItemSubHeader">
          See Also
        </h4>
        <ul class="catalogAdditionalItemList">
          <li v-for="seeAlsoItem in seeAlsoItems" :key="seeAlsoItem.Content">
            <a :href="seeAlsoItem.DetailProperties.Link" class="catalogAdditionalItemLink">{{ seeAlsoItem.DetailProperties.Title }}</a>
          </li>
        </ul>
      </div>
      -->
    </div>
  </div>
</template>

<script>
  import { CatalogService }           from "@/services/CatalogService"
  import { mapGetters }               from "vuex"
  import { ErrorLogService }          from "@/services/ErrorLogService"
  import LoadingSpinner               from "@/components/Elements/LoadingSpinner"
  import CatalogCard                  from "@/components/Elements/CatalogCard"
  import { constants }                from "@/const"
  import { brandAndRegionAuthHelper } from "@/components/mixins"

  export default {
    components: {
      LoadingSpinner,
      CatalogCard
    },
    mixins: [brandAndRegionAuthHelper],
    props: {
      category: {}
    },
    data: () => {
      return {
        //catalogItems is used as dictionary, (and the keys are integers therefore it must be an object to avoiding creating massive arrays)
        catalogItems: {},
        relatedDocuments: [],
        subCategoryiesAreLoading: {},
        areRelatedDocumentsLoading: true,
        haveInitiatedLoadForRelatedDocuments: false
        /* Fully Implemented, but not desired at this time
        areSeeAlsoItemsLoading: false,

        seeAlsoItems: [],
        */
      }
    },
    watch: {
      category: function() {

        if (this.IsNotNullOrUndefined(this, "category.ChildCategories") && this.category.Id > 0 && this.haveInitiatedLoadForRelatedDocuments === false)
        {
          this.haveInitiatedLoadForRelatedDocuments = true;
          this.GetRelatedDocuments();
          //Fully Implemented, but not desired at this time
          //this.GetSeeAlsoItems();
        }
      }
    },
    created() {
      this.GetRelatedDocuments();
    },
    computed: {
      ...mapGetters(["user", "activeAccountId", "CatalogRootByCategoryId"]),
      subCategories: function() {
        if(this.IsNotNullOrUndefined(this,"category.ChildCategories")){
          var authorizedChildCategories = this.category.ChildCategories.filter(x =>
            this.IsBrandRegionAuthorized(x.BrandAuth, x.RegionAuth)
          );
          if(authorizedChildCategories.length === 0){
            return [this.category];
          }
          return authorizedChildCategories.slice(0,5);
        }
        return [];
      }
    },
    methods: {
      MediaUrl(imageId)
      {
        return window.appGlobals.PART_IMAGES_API_URL + "Media/FileById?id="+imageId
      },
      GetRelatedDocuments(){
        let self = this;
        this.areRelatedDocumentsLoading = true;
      
        if( this.category.MegaMenuRelatedDocuments !== undefined){
          self.relatedDocuments = this.category.MegaMenuRelatedDocuments
            .filter( doc =>
              doc.ContentType === constants.CATEGORY_CONTENT_TYPES.RELATED_DOCUMENT &&
              doc.DetailProperties !== null &&
              this.IsBrandRegionAuthorized(parseInt(doc.DetailProperties.BrandAuth), parseInt(doc.DetailProperties.RegionAuth))
            )
            .slice(0, 5);
        }
        
        self.areRelatedDocumentsLoading = false
      },
      /* Fully Implemented, but not desired at this time
      GetSeeAlsoItems(){
        let self = this;
        this.areSeeAlsoItemsLoading = true;
        CatalogService.GetCategoryContentByTypes(this.category.Id, [constants.CATEGORY_CONTENT_TYPES.SEE_ALSO])
          .then( seeAlsoItems => {
            self.seeAlsoItems = seeAlsoItems.data.filter( x => x.ContentType === constants.CATEGORY_CONTENT_TYPES.SEE_ALSO)
              .slice(0, 5);
          }).catch(err => {
            ErrorLogService.LogException(err)
          }).finally(() => {
            self.areSeeAlsoItemsLoading = false
          })
      }
      */
    }
  }
</script>



<style lang="scss">

.catalog-preview-component{
  padding: 12px 8px 4px 0;
  h3 {
    margin-bottom: 0.75rem;
  }
  .catalogItemSubHeader {
    margin-top: 1rem;
  }
}


.cpc__mega-menu-categories-preview{
    .catalog-card{
        height: 150px;
        transition: box-shadow 0.15s ease, background-color 0.15s ease;
    }
    .catalog-card__title-wrapper{
        padding: 1px;
        font-size: 12px;
    }
}
.cpc__mega-menu-categories-preview--item-start{
    .cpc__mega-menu-categories-preview__col:not(:first-child){
        margin-left: 20px;
    }
}

.cpc__related-docs-ul {
  margin: 0;
  font-size: 14px;
  padding-left: 6px;
  list-style-type: disc;
}

.cpc__related-doc-li {
  display: list-item;
  list-style-type: disc;
  margin-left: 30px;
  margin-bottom: 4px;
}
</style>
